import { Injectable } from '@angular/core';
import { BaseDataSourceServiceV2, GetManyV2Dto, PageableListV2Dto, SnackbarService } from '@fleet-beat/core';
import { DataAutocompleteStorageParams } from '@fleet-beat/editor';
import { AuthService, CompanyStoreService } from '@fleet-beat/shared';
import { Observable } from 'rxjs';
import { DeviceDto, DevicesApiService } from '@fleet-beat/api';

@Injectable({
  providedIn: 'root',
})
export class DeviceListAutocompleteStorageService extends BaseDataSourceServiceV2<
  DeviceDto,
  DataAutocompleteStorageParams<object>
> {
  constructor(
    protected override snackbarService: SnackbarService,
    private authService: AuthService,
    private devicesApiService: DevicesApiService,
    private companyStoreService: CompanyStoreService,
  ) {
    super(snackbarService);
  }

  protected override getData(
    data: DataAutocompleteStorageParams<{ input: string; include?: string }>,
  ): Observable<PageableListV2Dto<DeviceDto>> {
    const { input, ...baseParams } = data.params as any;

    const params: GetManyV2Dto = {
      ...baseParams,
      ...data.extra,
      companyIds: this.companyStoreService.companyId,
    };
    if (input && input.trim() !== '') {
      params.search = input.trim();
    } else {
      delete params.search;
    }

    return this.devicesApiService.getMany(params, this.authService.authHeaders);
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  protected override getById(id: string): Observable<DeviceDto> {
    throw new Error('Not Implemented');
  }
}
